export default "__VITE_ASSET___aQ1vUqa__"